exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card.card--destiny{border-radius:15px}.v-card.card--destiny .v-card__price,.v-card.card--destiny .v-card__text h3{letter-spacing:0}.v-card.card--destiny .v-card__text h3{font-family:Avenir-Heavy}.v-card.card--destiny .v-card__price{font-family:Avenir}.v-card.card--destiny .v-card__text{padding:.8rem 1.5rem 0}.v-card.card--destiny .v-card__actions{padding:0 1rem .5rem 1.5rem}.v-card.card--destiny .v-card__actions .v-card__price{font-size:1rem;line-height:1.6rem;font-weight:900}.v-card.card--destiny .v-card__actions .v-btn{padding:0;margin:0}.v-card.card--destiny .v-card__actions .v-btn:hover:before{opacity:0}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};